"use strict";

(function () {
  const contactForms = Array.from(document.querySelectorAll(".js-contact-form"));
  contactForms.forEach(form => {
    if (form.dataset.inited) return;
    form.dataset.inited = "true";
    form.addEventListener("submit", function (event) {
      const checkbox = event.target.querySelector(".js-contact-form-terms");
      const error = event.target.querySelector(".js-contact-form-terms-error");
      if (checkbox && !checkbox.checked) {
        event.preventDefault();
        error.classList.remove("hidden");
      } else {
        error.classList.add("hidden");
      }
    });
  });
})();